/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkRoletype } from '../models/work-roletype';

@Injectable({ providedIn: 'root' })
export class WorkRoletypesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `roletypesV1ControllerFindAll()` */
  static readonly RoletypesV1ControllerFindAllPath = '/v1/roletypes';

  /**
   * Required permissions: users:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roletypesV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV1ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkRoletype>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkRoletypesService.RoletypesV1ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkRoletype>>;
      })
    );
  }

  /**
   * Required permissions: users:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `roletypesV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roletypesV1ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkRoletype>> {
    return this.roletypesV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkRoletype>>): Array<WorkRoletype> => r.body)
    );
  }

}
